/* CHILL catalog: smarter search, live suggestions, instant filters, quick add and product rows. */
(() => {
  'use strict';
  if (window.ChillCatalogReady) return;
  window.ChillCatalogReady = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const CAT_PARAM = 'filter.p.m.custom.chill_category';
  const GROUP_PARAM = 'filter.p.m.custom.chill_group';
  const CATEGORIES = {
    Vapes: 'internal-vapes', Hemp: 'internal-thca', THCA: 'internal-thca', Kratom: 'internal-kratom', Mushrooms: 'internal-mushrooms',
    'Smoke shop accessories': 'smoke-shop-accessories', 'Packaging and supplies': 'packaging-and-supplies'
  };
  const CAT_LABELS = { 'Smoke shop accessories': 'Smoke Shop', 'Packaging and supplies': 'Packaging' };
  const catLabel = (value) => CAT_LABELS[value] || value;
  const config = () => document.getElementById('ChillCatalogConfig')?.dataset || {};

  const cleanText = (value) => String(value || '').normalize('NFKC').replace(/[\p{Cc}\p{Zl}\p{Zp}]/gu, ' ').replace(/\s+/g, ' ').trim().slice(0, 120);
  const tokens = (value) => (cleanText(value).match(/[\p{L}\p{N}]+/gu) || []).filter((t) => !['AND', 'OR', 'NOT'].includes(t.toUpperCase())).slice(0, 8);

  /* ---------- Search vocabulary: POS abbreviations and typo correction ---------- */
  // POS titles abbreviate brands and flavors ("WTRMLN", "STRWB", "BATT"), so each word also matches its common spellings.
  const PHRASES = [
    ['geek bar', ['geekbar', 'geek bar']], ['elf bar', ['elfbar', 'elf bar']], ['lost mary', ['lost mary', 'lostmary']],
    ['zig zag', ['zigzag', 'zig zag']], ['king palm', ['kingpalm', 'king palm']], ['juicy jay', ['juicy jay', 'juicy jays', 'juicy']],
    ['blue razz', ['blue razz', 'blue raz', 'bl raz', 'braz']], ['pre roll', ['preroll', 'prerol', 'pre roll', 'pre rol']],
    ['pre rolls', ['preroll', 'prerol', 'pre roll']], ['hot knife', ['hot knife', 'hotknife']], ['dab rig', ['dab rig', 'e rig', 'erig']],
    ['e rig', ['e rig', 'erig']], ['white owl', ['white owl', 'wo']], ['good times', ['good times', 'gt']], ['mylar bag', ['mylar']],
    ['mylar bags', ['mylar']], ['rolling papers', ['papers', 'paper']], ['al fakher', ['al fakher', 'alfakher']],
    ['back woods', ['backwoods']], ['high hemp', ['high hemp']], ['bob marley', ['bob marley', 'marley']]
  ];
  const WORDS = {
    watermelon: ['watermelon', 'watermelo', 'wtrmln', 'wtrmel', 'wmelon', 'wmel', 'melon'], strawberry: ['strawberry', 'strawb', 'strwb', 'straw', 'strawbe'],
    blueberry: ['blueberry', 'bluebry', 'blueb', 'bluebe'], raspberry: ['raspberry', 'rasp', 'razz'], pineapple: ['pineapple', 'pineap', 'pinea', 'pine'],
    menthol: ['menthol', 'ment', 'mnth'], mint: ['mint', 'mnt'], grape: ['grape', 'grap'], mango: ['mango', 'mang'], peach: ['peach', 'pch'],
    cherry: ['cherry', 'chry', 'cher'], lemon: ['lemon', 'lmn'], lemonade: ['lemonade', 'lmnd', 'lemon'], tropical: ['tropical', 'trop'],
    original: ['original', 'orig', 'reg'], vanilla: ['vanilla', 'vani', 'van'], cotton: ['cotton', 'cott'], candy: ['candy', 'cndy'],
    battery: ['battery', 'batt', 'bat', 'batteries'], batteries: ['battery', 'batt', 'bat'], cartridge: ['cartridge', 'cart', 'carts'],
    cartridges: ['cartridge', 'cart', 'carts'], disposable: ['disposable', 'disp', 'dispo'], disposables: ['disposable', 'disp', 'dispo'],
    vaporizer: ['vaporizer', 'vaporiz', 'vape'], atomizer: ['atomizer', 'atom'], coil: ['coil', 'coils'], coils: ['coil', 'coils'],
    puffs: ['puffs', 'puff', 'puf'], puff: ['puff', 'puffs', 'puf'], torch: ['torch', 'torches'], torches: ['torch'], lighter: ['lighter', 'lighters'],
    lighters: ['lighter'], wraps: ['wraps', 'wrap'], wrap: ['wrap', 'wraps'], cones: ['cones', 'cone'], cone: ['cone', 'cones'],
    papers: ['papers', 'paper'], hookah: ['hookah', 'hooka'], shisha: ['shisha', 'shish'], mushroom: ['mushroom', 'mush', 'shroom'],
    mushrooms: ['mushroom', 'mush', 'shroom'], gummies: ['gummies', 'gummy', 'gumm', 'gumies'], gummy: ['gummy', 'gummies', 'gumm'],
    thca: ['thca', 'thc', 'hemp'], flower: ['flower', 'flr'], diamonds: ['diamonds', 'diamond'], kratom: ['kratom', 'krat'], kava: ['kava'],
    count: ['count', 'ct'], pack: ['pack', 'pk'], ounce: ['ounce', 'oz'], gram: ['gram', 'gr', 'g'], grams: ['gram', 'gr'],
    container: ['container', 'contain', 'cont'], containers: ['container', 'contain'], concentrate: ['concentrate', 'concen', 'conc'],
    grinder: ['grinder', 'grind'], butane: ['butane', 'butan'], nicotine: ['nicotine', 'nic'], black: ['black', 'blk'], white: ['white', 'wht'],
    purple: ['purple', 'prpl'], orange: ['orange', 'orng', 'oran'], green: ['green', 'grn'], assorted: ['assorted', 'asst', 'assrt']
  };
  let VOCAB = null;
  let vocabRequest = null;
  function loadVocab() {
    if (VOCAB) return Promise.resolve(VOCAB);
    if (vocabRequest) return vocabRequest;
    const url = config().vocabUrl;
    if (!url) return Promise.resolve(null);
    vocabRequest = fetch(url).then((r) => (r.ok ? r.json() : null)).then((data) => {
      if (!data || typeof data.w !== 'string') return null;
      const map = new Map();
      data.w.split(',').forEach((entry) => { const [word, count] = entry.split(':'); if (word) map.set(word, Number(count) || 1); });
      VOCAB = { map, words: [...map.keys()] };
      return VOCAB;
    }).catch(() => null);
    return vocabRequest;
  }
  function distance(a, b, limit) {
    if (Math.abs(a.length - b.length) > limit) return limit + 1;
    let prev2 = null;
    let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 1; i <= a.length; i += 1) {
      const row = [i];
      let best = i;
      for (let j = 1; j <= b.length; j += 1) {
        let value = Math.min(prev[j] + 1, row[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) value = Math.min(value, prev2[j - 2] + 1);
        row.push(value);
        if (value < best) best = value;
      }
      if (best > limit) return limit + 1;
      prev2 = prev;
      prev = row;
    }
    return prev[b.length];
  }
  const corrections = new Map();
  function correctWord(word) {
    if (!VOCAB || word.length < 4 || !/^[a-z]+$/u.test(word) || WORDS[word]) return '';
    if (corrections.has(word)) return corrections.get(word);
    let result = '';
    if (!VOCAB.map.has(word) && !VOCAB.words.some((entry) => entry.startsWith(word))) {
      const limit = word.length >= 7 ? 2 : 1;
      let bestScore = Infinity;
      VOCAB.words.forEach((entry) => {
        if (entry.length < 3) return;
        const d = distance(word, entry, limit);
        if (d > limit) return;
        const score = d * 100000 - (VOCAB.map.get(entry) || 1);
        if (score < bestScore) { bestScore = score; result = entry; }
      });
    }
    corrections.set(word, result);
    return result;
  }
  const correctText = (text) => cleanText(text).replace(/[\p{L}\p{N}]+/gu, (t) => correctWord(t.toLowerCase()) || t);

  const quoted = (value) => `"${String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
  const wordClause = (w) => `title:${w}* OR variants.sku:${w}* OR variants.barcode:${w}* OR vendor:${w}*`;
  const altClause = (alt) => {
    const parts = alt.match(/[\p{L}\p{N}]+/gu) || [];
    if (!parts.length) return '';
    return parts.length === 1 ? wordClause(parts[0]) : `(${parts.map((p) => `title:${p}*`).join(' AND ')})`;
  };
  function keywordGroups(text) {
    let rest = ` ${cleanText(text).toLowerCase().replace(/-/g, ' ')} `;
    const groups = [];
    PHRASES.forEach(([phrase, alts]) => {
      if (rest.includes(` ${phrase} `)) { groups.push(alts); rest = rest.replace(` ${phrase} `, ' '); }
    });
    tokens(rest).forEach((token) => {
      const typed = token.toLowerCase();
      const fixed = correctWord(typed);
      const lower = fixed || typed;
      const alts = new Set(WORDS[lower] || [lower]);
      if (fixed) alts.add(typed);
      if (!WORDS[lower] && lower.length >= 8) alts.add(lower.slice(0, 7)); // POS titles truncate long words
      groups.push([...alts]);
    });
    return groups.slice(0, 8);
  }
  function buildQuery(text) {
    const term = cleanText(text);
    if (!term) return '';
    // A stock number or barcode on its own is matched exactly as well as by prefix.
    if (/^\d{5,14}$/.test(term)) return `variants.barcode:${term} OR variants.sku:${term}* OR title:${term}*`;
    const groups = keywordGroups(term);
    if (!groups.length) return term;
    return groups.map((alts) => `(${alts.map(altClause).filter(Boolean).join(' OR ')})`).join(' AND ');
  }

  // Everyday words that should open a category or product group instead of a keyword search.
  const SHORTCUTS = {
    vape: ['Vapes'], vapes: ['Vapes'], 'e cig': ['Vapes'], ecig: ['Vapes'], 'e cigs': ['Vapes'],
    disposable: ['Vapes', 'Disposables'], disposables: ['Vapes', 'Disposables'], dispo: ['Vapes', 'Disposables'], dispos: ['Vapes', 'Disposables'],
    'disposable vape': ['Vapes', 'Disposables'], 'disposable vapes': ['Vapes', 'Disposables'],
    batteries: ['Vapes', '510 Batteries'], battery: ['Vapes', '510 Batteries'], '510': ['Vapes', '510 Batteries'], '510 battery': ['Vapes', '510 Batteries'],
    pods: ['Vapes', 'Pods & Cartridges'], carts: ['Vapes', 'Pods & Cartridges'], cartridges: ['Vapes', 'Pods & Cartridges'],
    coils: ['Vapes', 'Coils & Atomizers'], atomizers: ['Vapes', 'Coils & Atomizers'], 'dab rig': ['Vapes', 'Vaporizers & E-Rigs'],
    'dab rigs': ['Vapes', 'Vaporizers & E-Rigs'], 'e rig': ['Vapes', 'Vaporizers & E-Rigs'], rigs: ['Vapes', 'Vaporizers & E-Rigs'],
    vaporizer: ['Vapes', 'Vaporizers & E-Rigs'], vaporizers: ['Vapes', 'Vaporizers & E-Rigs'], 'dry herb': ['Vapes', 'Vaporizers & E-Rigs'],
    'hot knife': ['Vapes', 'Hot Knives & Dab Tools'], 'dab tools': ['Vapes', 'Hot Knives & Dab Tools'], 'e liquid': ['Vapes', 'E-Liquid'],
    'e juice': ['Vapes', 'E-Liquid'], mods: ['Vapes', 'Mods & Kits'], 'vape kits': ['Vapes', 'Mods & Kits'],
    thca: ['Hemp'], 'thc a': ['Hemp'], thc: ['Hemp'], hemp: ['Hemp'], flower: ['Hemp', 'Flower'], 'thca flower': ['Hemp', 'Flower'], 'hemp flower': ['Hemp', 'Flower'],
    'pre roll': ['Hemp', 'Pre-Rolls'], 'pre rolls': ['Hemp', 'Pre-Rolls'], preroll: ['Hemp', 'Pre-Rolls'], prerolls: ['Hemp', 'Pre-Rolls'],
    joints: ['Hemp', 'Pre-Rolls'], diamonds: ['Hemp', 'Concentrates & Diamonds'], concentrates: ['Hemp', 'Concentrates & Diamonds'],
    kratom: ['Kratom'], kava: ['Kratom'], mushroom: ['Mushrooms'], mushrooms: ['Mushrooms'], shrooms: ['Mushrooms'], amanita: ['Mushrooms', 'Amanita Gummies'],
    'smoke shop': ['Smoke shop accessories'], accessories: ['Smoke shop accessories'], papers: ['Smoke shop accessories', 'Papers & Cones'],
    'rolling papers': ['Smoke shop accessories', 'Papers & Cones'], cones: ['Smoke shop accessories', 'Papers & Cones'],
    wraps: ['Smoke shop accessories', 'Wraps'], 'blunt wraps': ['Smoke shop accessories', 'Wraps'], 'hemp wraps': ['Smoke shop accessories', 'Wraps'],
    lighters: ['Smoke shop accessories', 'Lighters & Torches'], lighter: ['Smoke shop accessories', 'Lighters & Torches'],
    torch: ['Smoke shop accessories', 'Lighters & Torches'], torches: ['Smoke shop accessories', 'Lighters & Torches'],
    butane: ['Smoke shop accessories', 'Butane & Fluid'], hookah: ['Smoke shop accessories', 'Hookah & Shisha'], shisha: ['Smoke shop accessories', 'Hookah & Shisha'],
    hookahs: ['Smoke shop accessories', 'Hookah & Shisha'], glass: ['Smoke shop accessories', 'Glass, Pipes & Grinders'],
    pipes: ['Smoke shop accessories', 'Glass, Pipes & Grinders'], grinders: ['Smoke shop accessories', 'Glass, Pipes & Grinders'],
    grinder: ['Smoke shop accessories', 'Glass, Pipes & Grinders'], knives: ['Smoke shop accessories', 'Knives & Novelties'],
    'filter tubes': ['Smoke shop accessories', 'Filter Tubes & Rollers'], rollers: ['Smoke shop accessories', 'Filter Tubes & Rollers'],
    packaging: ['Packaging and supplies'], 'branded packaging': ['Packaging and supplies'], mylar: ['Packaging and supplies', 'Mylar Bags'],
    'mylar bags': ['Packaging and supplies', 'Mylar Bags'], bags: ['Packaging and supplies', 'Mylar Bags'], jars: ['Packaging and supplies', 'Jars'],
    'dram tubes': ['Packaging and supplies', 'Pre-Roll & Dram Tubes'], 'pre roll tubes': ['Packaging and supplies', 'Pre-Roll & Dram Tubes'],
    'doob tubes': ['Packaging and supplies', 'Pre-Roll & Dram Tubes'], containers: ['Packaging and supplies', 'Concentrate Containers'],
    'concentrate containers': ['Packaging and supplies', 'Concentrate Containers'], boveda: ['Packaging and supplies', 'Storage & Humidity']
  };
  function categoryUrl(category, group) {
    const handle = CATEGORIES[category];
    if (!handle) return null;
    const url = new URL(`${ROOT}collections/${handle}`, location.origin);
    if (group) url.searchParams.set(GROUP_PARAM, group);
    return url;
  }
  function shortcut(text) {
    const typed = cleanText(text).toLowerCase().replace(/-/g, ' ');
    if (!typed) return null;
    for (const key of [typed, correctText(typed).toLowerCase()]) {
      const hit = SHORTCUTS[key];
      if (hit) return categoryUrl(hit[0], hit[1]);
    }
    return null;
  }

  function searchUrl(text, { category = '', view = '', keepFilters = null } = {}) {
    const term = cleanText(text);
    const url = new URL(`${ROOT}search`, location.origin);
    if (view) url.searchParams.set('view', view);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    url.searchParams.set('q', buildQuery(term) || term);
    url.searchParams.set('cq', term);
    const fixed = correctText(term);
    if (fixed.toLowerCase() !== term.toLowerCase()) url.searchParams.set('cq_fix', fixed);
    if (category) url.searchParams.set(CAT_PARAM, category);
    if (keepFilters) keepFilters.forEach(([k, v]) => url.searchParams.append(k, v));
    return url;
  }

  /* ---------- Search forms and live suggestions ---------- */
  function setupSearch(shell) {
    if (shell.dataset.ready) return;
    shell.dataset.ready = 'true';
    const form = shell.querySelector('[data-chill-search-form]');
    const input = shell.querySelector('[data-chill-search-input]');
    const cat = shell.querySelector('[data-chill-search-cat]');
    const panel = shell.querySelector('[data-chill-suggest]');
    const status = shell.querySelector('[data-chill-suggest-status]');
    if (!form || !input || !panel) return;
    const params = new URLSearchParams(location.search);
    if (params.get('cq')) input.value = params.get('cq');
    if (cat && params.get(CAT_PARAM) && [...cat.options].some((o) => o.value === params.get(CAT_PARAM))) cat.value = params.get(CAT_PARAM);
    const pageCategory = document.querySelector('[data-chill-page]')?.closest('body')?.dataset.chillCategory;
    if (cat && !cat.value && pageCategory) cat.value = pageCategory;

    let timer; let controller; let active = -1; let options = []; let seq = 0;
    const cache = new Map();
    const close = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      shell.classList.remove('is-suggesting');
      active = -1;
    };
    const cancel = () => { clearTimeout(timer); controller?.abort(); seq += 1; };
    function show(markup, term, category) {
      if (document.activeElement !== input && !shell.contains(document.activeElement)) return;
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const root = doc.querySelector('[data-chill-suggest-root]');
      if (!root) { close(); return; }
      panel.replaceChildren(...root.childNodes);
      const all = panel.querySelector('[data-chill-suggest-all]');
      if (all) all.href = searchUrl(term, { category }).href;
      const shortcutUrl = shortcut(term);
      if (shortcutUrl) {
        const hit = SHORTCUTS[cleanText(term).toLowerCase().replace(/-/g, ' ')] || SHORTCUTS[correctText(term).toLowerCase()];
        const jump = document.createElement('a');
        jump.className = 'chill-suggest__jump';
        jump.href = shortcutUrl.href;
        jump.setAttribute('data-chill-suggest-option', '');
        jump.textContent = `Browse ${hit && hit[1] ? hit[1] : catLabel(hit ? hit[0] : '')}`;
        panel.prepend(jump);
      }
      const fixed = correctText(term);
      if (fixed.toLowerCase() !== cleanText(term).toLowerCase()) {
        const note = document.createElement('p');
        note.className = 'chill-suggest__fix';
        note.textContent = `Showing results for “${fixed}”`;
        panel.prepend(note);
      }
      options = [...panel.querySelectorAll('[data-chill-suggest-option], [data-chill-suggest-all]')];
      options.forEach((option, i) => {
        option.id = `${panel.id}-opt-${i}`;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.tabIndex = -1;
      });
      active = -1;
      panel.hidden = false;
      shell.classList.add('is-suggesting');
      input.setAttribute('aria-expanded', 'true');
      if (status) status.textContent = `${root.dataset.count || 0} products found`;
    }
    async function suggest() {
      cancel();
      const term = cleanText(input.value);
      if (term.length < 2) { close(); return; }
      await loadVocab();
      const category = cat ? cat.value : '';
      const url = searchUrl(term, { category, view: 'chill-suggest' });
      const key = url.href;
      if (cache.has(key)) { show(cache.get(key), term, category); return; }
      const mine = ++seq;
      controller = new AbortController();
      try {
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('unavailable');
        const html = await response.text();
        if (mine !== seq) return;
        if (cache.size > 40) cache.delete(cache.keys().next().value);
        cache.set(key, html);
        show(html, term, category);
      } catch (error) {
        if (error.name !== 'AbortError') close();
      }
    }
    input.addEventListener('input', () => { cancel(); timer = setTimeout(suggest, 200); });
    input.addEventListener('focus', () => { if (cleanText(input.value).length >= 2) suggest(); });
    cat?.addEventListener('change', () => { if (cleanText(input.value).length >= 2) suggest(); else input.focus(); });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { if (!panel.hidden) { event.preventDefault(); cancel(); close(); } return; }
      if (panel.hidden || !options.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        active = event.key === 'ArrowDown' ? (active + 1) % options.length : (active <= 0 ? options.length - 1 : active - 1);
        options.forEach((o, i) => o.setAttribute('aria-selected', String(i === active)));
        input.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && active >= 0) {
        event.preventDefault();
        location.assign(options[active].href);
      }
    });
    shell.addEventListener('focusout', (event) => { if (!shell.contains(event.relatedTarget)) { cancel(); close(); } });
    panel.addEventListener('pointerdown', (event) => { if (event.target.closest('a')) event.preventDefault(); });
    panel.addEventListener('click', (event) => { const a = event.target.closest('a'); if (a) { event.preventDefault(); location.assign(a.href); } });
    form.addEventListener('submit', async (event) => {
      const term = cleanText(input.value);
      event.preventDefault();
      cancel(); close();
      if (!term) { const c = cat?.value; location.assign(c ? categoryUrl(c).href : `${ROOT}search`); return; }
      await loadVocab();
      const category = cat ? cat.value : '';
      const jump = !category ? shortcut(term) : null;
      location.assign((jump || searchUrl(term, { category })).href);
    });
  }

  /* ---------- Search results page: friendly heading, correction note, widening ---------- */
  function setupSearchPage() {
    const page = document.querySelector('[data-chill-search-page]');
    if (!page) return;
    const params = new URLSearchParams(location.search);
    const typed = params.get('cq');
    const heading = page.querySelector('[data-chill-search-heading]');
    const note = page.querySelector('[data-chill-fix-note]');
    const count = Number(page.querySelector('[data-chill-catalog]')?.dataset.count || 0);
    const category = params.get(CAT_PARAM);
    // Plain ?q= searches (old links, no JavaScript at submit) are upgraded to the expanded query once.
    if (!typed && params.get('q') && !/[:*]/.test(params.get('q'))) {
      loadVocab().then(() => {
        const extra = [...params].filter(([k]) => k.startsWith('filter.') || k === 'sort_by');
        location.replace(searchUrl(params.get('q'), { keepFilters: extra }).href);
      });
      return;
    }
    if (typed && heading) heading.textContent = `Results for “${typed}”${category ? ` in ${catLabel(category)}` : ''}`;
    if (typed) document.title = `Search: ${typed} | CHILL Wholesale`;
    const messages = [];
    if (params.get('cq_fix')) messages.push(`Showing results for “${params.get('cq_fix')}”.`);
    if (params.get('cq_wide')) messages.push(`No matches in ${catLabel(params.get('cq_wide'))}, so we searched every category.`);
    if (note && messages.length) { note.textContent = messages.join(' '); note.hidden = false; }
    if (count === 0 && category && typed) {
      const wide = new URL(location.href);
      wide.searchParams.delete(CAT_PARAM);
      wide.searchParams.delete('page');
      wide.searchParams.set('cq_wide', category);
      location.replace(wide.href);
    }
    page.querySelectorAll('[data-chill-starter]').forEach((a) => {
      a.addEventListener('click', async (event) => {
        event.preventDefault();
        await loadVocab();
        location.assign((shortcut(a.dataset.chillStarter) || searchUrl(a.dataset.chillStarter)).href);
      });
    });
  }

  /* ---------- Catalog: instant filters, drawer, find box, density ---------- */
  let loadController;
  function catalogRoot() { return document.querySelector('[data-chill-catalog]'); }
  async function loadCatalog(url, { push = true } = {}) {
    const root = catalogRoot();
    if (!root) { location.assign(url); return; }
    const sectionId = root.dataset.sectionId;
    const target = new URL(url, location.origin);
    target.searchParams.delete('page');
    if (url instanceof URL && url.searchParams.get('page')) target.searchParams.set('page', url.searchParams.get('page'));
    const fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', sectionId);
    loadController?.abort();
    loadController = new AbortController();
    root.classList.add('is-loading');
    try {
      const response = await fetch(fetchUrl, { signal: loadController.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-chill-catalog]');
      if (!next) throw new Error('missing');
      const wasOpen = root.querySelector('[data-chill-sidebar]')?.classList.contains('is-open');
      const openFacets = new Set([...root.querySelectorAll('[data-chill-facet]')].map((d) => `${d.querySelector('summary span')?.textContent}:${d.open}`));
      root.replaceWith(next);
      next.querySelectorAll('[data-chill-facet]').forEach((d) => {
        const label = d.querySelector('summary span')?.textContent;
        if (openFacets.has(`${label}:true`)) d.open = true;
        else if (openFacets.has(`${label}:false`) && !d.querySelector('input:checked')) d.open = false;
      });
      if (push) history.pushState({ chill: true }, '', target.href);
      initCatalog(next);
      if (wasOpen) openDrawer(next, false);
      const top = next.getBoundingClientRect().top + window.scrollY - 90;
      if (!wasOpen && window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(target.href);
    } finally {
      document.querySelector('[data-chill-catalog]')?.classList.remove('is-loading');
    }
  }
  function urlFromForm(root) {
    const form = root.querySelector('[data-chill-filters]');
    const url = new URL(location.href);
    [...url.searchParams.keys()].filter((k) => k.startsWith('filter.') && !(k === GROUP_PARAM && root.dataset.context === 'collection') && !(k === CAT_PARAM))
      .forEach((k) => url.searchParams.delete(k));
    url.searchParams.delete('page');
    url.searchParams.delete('cq_wide');
    new FormData(form).forEach((value, key) => { if (String(value).trim() !== '') url.searchParams.append(key, value); });
    const sort = root.querySelector('[data-chill-sort]');
    if (sort) url.searchParams.set('sort_by', sort.value);
    return url;
  }
  function openDrawer(root, focus = true) {
    const side = root.querySelector('[data-chill-sidebar]');
    const backdrop = root.querySelector('.chill-sidebar-backdrop');
    if (!side) return;
    side.classList.add('is-open');
    if (backdrop) backdrop.hidden = false;
    document.documentElement.classList.add('chill-drawer-open');
    root.querySelector('[data-chill-drawer-open]')?.setAttribute('aria-expanded', 'true');
    if (focus) side.querySelector('.chill-sidebar__head button')?.focus();
  }
  function closeDrawer(root) {
    const side = root.querySelector('[data-chill-sidebar]');
    const backdrop = root.querySelector('.chill-sidebar-backdrop');
    side?.classList.remove('is-open');
    if (backdrop) backdrop.hidden = true;
    document.documentElement.classList.remove('chill-drawer-open');
    root.querySelector('[data-chill-drawer-open]')?.setAttribute('aria-expanded', 'false');
  }
  function applyDensity(root) {
    let mode = 'grid';
    try { mode = localStorage.getItem('chill-density') || 'grid'; } catch (_) { /* private mode */ }
    root.querySelectorAll('[data-chill-grid]').forEach((grid) => grid.classList.toggle('chill-grid--list', mode === 'list'));
    root.querySelectorAll('[data-chill-density]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.chillDensity === mode)));
  }
  function initCatalog(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    applyDensity(root);
    const form = root.querySelector('[data-chill-filters]');
    let priceTimer;
    form?.addEventListener('change', (event) => {
      if (event.target.matches('[data-chill-find]')) return;
      if (event.target.matches('[data-chill-price]')) { clearTimeout(priceTimer); priceTimer = setTimeout(() => loadCatalog(urlFromForm(root)), 350); return; }
      loadCatalog(urlFromForm(root));
    });
    form?.addEventListener('submit', (event) => { event.preventDefault(); loadCatalog(urlFromForm(root)); });
    root.querySelector('[data-chill-sort]')?.addEventListener('change', () => loadCatalog(urlFromForm(root)));
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-chill-link], .chill-catalog .pagination a');
      if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && link.origin === location.origin) {
        const target = new URL(link.href);
        const samePage = target.pathname === location.pathname;
        if (samePage) { event.preventDefault(); loadCatalog(target); return; }
      }
      const clear = event.target.closest('[data-chill-clear]');
      if (clear) {
        event.preventDefault();
        const url = new URL(location.href);
        [...url.searchParams.keys()].filter((k) => k.startsWith('filter.') || k === 'page').forEach((k) => url.searchParams.delete(k));
        loadCatalog(url);
        return;
      }
      if (event.target.closest('[data-chill-drawer-open]')) { openDrawer(root); return; }
      if (event.target.closest('[data-chill-drawer-close]')) { closeDrawer(root); return; }
      const density = event.target.closest('[data-chill-density]');
      if (density) {
        try { localStorage.setItem('chill-density', density.dataset.chillDensity); } catch (_) { /* ignore */ }
        applyDensity(root);
        return;
      }
      const more = event.target.closest('[data-chill-more]');
      if (more) {
        const facet = more.closest('[data-chill-facet]');
        const hidden = facet.querySelectorAll('.is-more');
        const expanding = [...hidden].some((li) => li.hidden);
        hidden.forEach((li) => { li.hidden = !expanding; });
        more.textContent = expanding ? 'Show fewer' : `Show all ${more.dataset.total}`;
      }
    });
    root.addEventListener('input', (event) => {
      const find = event.target.closest('[data-chill-find]');
      if (!find) return;
      const term = find.value.trim().toLowerCase();
      const facet = find.closest('[data-chill-facet]');
      const more = facet.querySelector('[data-chill-more]');
      facet.querySelectorAll('.chill-facet__values li').forEach((li) => {
        li.hidden = term ? !li.dataset.label.includes(term) : li.classList.contains('is-more') && !li.querySelector('input:checked');
      });
      if (more) more.hidden = Boolean(term);
    });
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(root); });
  }
  window.addEventListener('popstate', () => { if (catalogRoot()) loadCatalog(location.href, { push: false }); });

  /* ---------- Quick add: card steppers, add without leaving the page, toast and fly-to-cart ---------- */
  const cartIcon = () => [...document.querySelectorAll('.cart-link')].find((el) => el.offsetParent !== null);
  function updateCartCount() {
    fetch(`${ROOT}cart.js`, { credentials: 'same-origin' }).then((r) => r.json()).then((cart) => {
      document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count < 1); });
    }).catch(() => {});
  }
  function bump() {
    const icon = cartIcon();
    if (!icon) return;
    icon.classList.remove('chill-bump');
    void icon.offsetWidth;
    icon.classList.add('chill-bump');
  }
  function fly(from, image) {
    const icon = cartIcon();
    if (!icon || !from || !image || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { bump(); return; }
    const a = from.getBoundingClientRect();
    const b = icon.getBoundingClientRect();
    const dot = document.createElement('img');
    dot.src = image; dot.alt = ''; dot.className = 'chill-fly';
    dot.style.left = `${a.left + a.width / 2 - 24}px`;
    dot.style.top = `${a.top + a.height / 2 - 24}px`;
    document.body.append(dot);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = dot.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 60}px) scale(.8)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(.25)`, opacity: 0.4 }
    ], { duration: 650, easing: 'cubic-bezier(.4,0,.2,1)' });
    anim.onfinish = () => { dot.remove(); bump(); };
  }
  let toastTimer;
  function toast({ title, quantity, image, error }) {
    let el = document.querySelector('.chill-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'chill-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.append(el);
    }
    el.classList.toggle('chill-toast--error', Boolean(error));
    el.replaceChildren();
    if (image && !error) { const img = document.createElement('img'); img.src = image; img.alt = ''; el.append(img); }
    const copy = document.createElement('div');
    const head = document.createElement('strong');
    head.textContent = error ? 'Could not add to cart' : `Added to cart${quantity ? ` · ${quantity}` : ''}`;
    const sub = document.createElement('span');
    sub.textContent = error || title || '';
    copy.append(head, sub);
    el.append(copy);
    if (!error) {
      const view = document.createElement('a');
      view.href = `${ROOT}cart`;
      view.textContent = 'View cart';
      el.append(view);
    }
    requestAnimationFrame(() => el.classList.add('chill-toast--show'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('chill-toast--show'), error ? 5000 : 3200);
  }
  async function addToCart(id, quantity) {
    const response = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] })
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-chill-step]');
    if (!step) return;
    const input = step.closest('[data-chill-qa]')?.querySelector('input[name="quantity"]');
    if (!input) return;
    const by = (Number(input.step) || 1) * Number(step.dataset.chillStep);
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + by));
  });
  // Capture phase so the product page form is handled here instead of redirecting to the cart.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-chill-qa], [data-chill-product-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.busy) return;
    const button = form.querySelector('[type="submit"]');
    const id = form.querySelector('input[name="id"]')?.value;
    const input = form.querySelector('input[name="quantity"]');
    if (input && !input.reportValidity()) return;
    const quantity = Math.max(Number(input?.min) || 1, Number(input?.value) || 1);
    form.dataset.busy = 'true';
    form.classList.add('is-busy');
    if (button) button.disabled = true;
    try {
      await addToCart(id, quantity);
      form.classList.add('is-added');
      fly(button, form.dataset.image);
      toast({ title: form.dataset.title, quantity, image: form.dataset.image });
      updateCartCount();
      setTimeout(() => form.classList.remove('is-added'), 1600);
    } catch (error) {
      toast({ error: error.message });
    } finally {
      delete form.dataset.busy;
      form.classList.remove('is-busy');
      if (button) button.disabled = false;
    }
  }, true);

  /* ---------- Product rows ("More like this") ---------- */
  function setupRows() {
    const rows = document.querySelectorAll('[data-chill-row]');
    if (!rows.length) return;
    const load = async (row) => {
      try {
        const response = await fetch(row.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('row');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = [...doc.querySelectorAll('[data-chill-row-root] .chill-card')].filter((c) => c.dataset.productId !== row.dataset.exclude).slice(0, 12);
        if (cards.length < 2) { row.remove(); return; }
        row.querySelector('[data-chill-row-track]').append(...cards);
        row.classList.add('is-loaded');
      } catch (_) { row.remove(); }
    };
    if (!('IntersectionObserver' in window)) { rows.forEach(load); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } }), { rootMargin: '400px' });
    rows.forEach((row) => io.observe(row));
  }

  // Keep sticky sidebar/toolbar clear of the sticky header; on phones the header compacts and sticks once scrolled.
  function setupStickyOffsets() {
    const header = document.querySelector('.shopify-section-group-header-group, #shopify-section-header-group-main');
    const measure = () => {
      const sticky = header && getComputedStyle(header).position === 'sticky';
      const height = sticky ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--chill-top', `${Math.round(height) + (window.innerWidth > 989 ? 16 : 0)}px`);
    };
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const isCompact = document.body.classList.contains('chill-compact-header');
        const compact = isCompact ? window.scrollY > 40 : window.scrollY > 220;
        if (isCompact !== compact && header) {
          // Keep the page the same height while the header shrinks, so the scroll position never jumps
          // (a jump is what made the header flip back and forth).
          if (compact) {
            const full = header.getBoundingClientRect().height;
            document.body.classList.add('chill-compact-header');
            const small = header.getBoundingClientRect().height;
            header.style.marginBottom = `${Math.max(0, full - small)}px`;
          } else {
            document.body.classList.remove('chill-compact-header');
            header.style.marginBottom = '';
          }
          measure();
        }
        ticking = false;
      });
    };
    const resync = () => {
      if (header && document.body.classList.contains('chill-compact-header')) {
        document.body.classList.remove('chill-compact-header');
        header.style.marginBottom = '';
        const full = header.getBoundingClientRect().height;
        document.body.classList.add('chill-compact-header');
        header.style.marginBottom = `${Math.max(0, full - header.getBoundingClientRect().height)}px`;
      }
      measure();
    };
    measure();
    window.addEventListener('resize', resync);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // "Sign in" links open Shopify's account sheet in place (email code, no separate page) when it is available.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-chill-login]');
    if (!link || event.metaKey || event.ctrlKey) return;
    const sheet = document.querySelector('shopify-account');
    if (!sheet || !customElements.get('shopify-account')) return;
    const trigger = sheet.shadowRoot?.querySelector('[part~="signed-out-avatar"]') || sheet;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    trigger.click();
  });

  function init() {
    setupStickyOffsets();
    document.querySelectorAll('[data-chill-search-shell]').forEach(setupSearch);
    setupSearchPage();
    initCatalog(catalogRoot());
    setupRows();
    if (document.querySelector('[data-chill-search-shell]')) setTimeout(loadVocab, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.ChillCatalog = Object.freeze({ buildQuery, searchUrl, shortcut, loadVocab, correctText });
})();
